<template>
    <button-base styleType="myflow">
        <slot></slot>
    </button-base>
</template>
